import type { ValidationAddress } from "@/services/address-validation/address-validation.types";
import type { Platform } from "@/services/device-options/device-options.types";

/** Recorded as the layout when a chosen device offers no keyboard layouts, so a device with none still satisfies the step. */
export const NO_KEYBOARD_LAYOUT = "__NO_KEYBOARD_LAYOUT__";

export type DeliveryMethod = "pickup" | "ship";

export type PickupDeliveryMethod = "BSC" | "IT_OFFICE";

export interface PickupSelection {
  deliveryMethod: PickupDeliveryMethod;
  buildingCode: string;
}

/**
 * A saved address, exactly as HOP accepted it: the request HOP validated, or HOP's suggestion the employee
 * confirmed. The order MUST send `address` unchanged, so it cannot fail on a value HOP never validated.
 */
export interface ValidatedAddress {
  address: ValidationAddress;
  /** Shown with the phone number on screen; never sent to HOP, which takes the national number. */
  phoneCountryCode: string;
  /** Sent with the order as HOP's `shippingAddress.deliveryInstructions`; HOP's validation does not take it. */
  deliveryInstructions?: string;
}

export interface ReplacementDraft {
  platform?: Platform;
  deviceId?: string;
  keyboardLayout?: string;
  deliveryMethod?: DeliveryMethod;
  pickup?: PickupSelection;
  shippingAddress?: ValidatedAddress;
  /** The employee has a form open over something already saved; each step's `validate` decides what that blocks. */
  isEditing?: boolean;
  homeAddress?: ValidatedAddress;
}

export interface ReplacementNavState {
  assetId: string;
  category: string;
  modelName: string;
}
